module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "gPageBorder",
    attrs: {
      "id": ""
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.info ? _vm.info.status == 3 : false),
      expression: "info?info.status == 3:false"
    }]
  }, [_c('el-alert', {
    staticStyle: {
      "display": "-webkit-flex",
      "margin": "0 0 5px 0"
    },
    attrs: {
      "title": _vm.reason,
      "type": "error",
      "show-icon": ""
    }
  })], 1), _vm._v(" "), _c('el-form', {
    ref: "firm",
    staticClass: "gForm",
    attrs: {
      "label-position": "right",
      "rules": _vm.rules,
      "label-width": "12.5%",
      "model": _vm.firm
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_srcname'),
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": ""
    },
    model: {
      value: (_vm.firm.name),
      callback: function($$v) {
        _vm.$set(_vm.firm, "name", $$v)
      },
      expression: "firm.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_srcdesc'),
      "prop": "desc"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": ""
    },
    model: {
      value: (_vm.firm.desc),
      callback: function($$v) {
        _vm.$set(_vm.firm, "desc", $$v)
      },
      expression: "firm.desc"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_distributor'),
      "prop": "mech"
    }
  }, [_c('MechanismSelector', {
    attrs: {
      "data": _vm.mechanismData
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_ulfile'),
      "prop": "url"
    }
  }, [_c('el-upload', {
    staticClass: "upload-demo",
    attrs: {
      "name": "fileUpload",
      "action": _vm.fileUploadUrl,
      "before-upload": _vm.srcBefore,
      "on-success": _vm.srcSuccess,
      "file-list": _vm.srcList
    }
  }, [_c('el-button', {
    attrs: {
      "size": "",
      "type": "primary"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_clickUpdate')))])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_version'),
      "prop": "ver"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": ""
    },
    model: {
      value: (_vm.firm.ver),
      callback: function($$v) {
        _vm.$set(_vm.firm, "ver", $$v)
      },
      expression: "firm.ver"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": ""
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v(_vm._s(_vm.$t('app_cancel')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.save('firm')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_save')))])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1fc85f4b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/nonintelligent/src/edit.vue
// module id = 990
// module chunks = 0